/* tslint:disable */
/* eslint-disable */
/**
 * Documents API
 * CDI Documents API
 *
 * The version of the OpenAPI document: 1.33.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists, mapValues } from '../runtime';
import { IdNameFromJSON, IdNameFromJSONTyped, IdNameToJSON } from './IdName';
import { IdNameParentFromJSON, IdNameParentFromJSONTyped, IdNameParentToJSON } from './IdNameParent';
import { TranslationsFromJSON, TranslationsFromJSONTyped, TranslationsToJSON } from './Translations';
/**
 * Check if a given object implements the SearchItems interface.
 */
export function instanceOfSearchItems(value) {
    let isInstance = true;
    return isInstance;
}
export function SearchItemsFromJSON(json) {
    return SearchItemsFromJSONTyped(json, false);
}
export function SearchItemsFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: !exists(json, 'id') ? undefined : json['id'],
        resource: !exists(json, 'resource') ? undefined : json['resource'],
        categories: !exists(json, 'categories')
            ? undefined
            : json['categories'].map(IdNameParentFromJSON),
        tags: !exists(json, 'tags')
            ? undefined
            : json['tags'].map(IdNameFromJSON),
        documentType: !exists(json, 'documentType') ? undefined : json['documentType'],
        publicationDate: !exists(json, 'publicationDate')
            ? undefined
            : new Date(json['publicationDate']),
        publisher: !exists(json, 'publisher') ? undefined : IdNameFromJSON(json['publisher']),
        collection: !exists(json, 'collection')
            ? undefined
            : IdNameFromJSON(json['collection']),
        match: !exists(json, 'match') ? undefined : json['match'],
        matchTotal: !exists(json, 'matchTotal') ? undefined : json['matchTotal'],
        authors: !exists(json, 'authors')
            ? undefined
            : json['authors'].map(IdNameFromJSON),
        translations: !exists(json, 'translations')
            ? undefined
            : json['translations'].map(TranslationsFromJSON)
    };
}
export function SearchItemsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        resource: value.resource,
        categories: value.categories === undefined
            ? undefined
            : value.categories.map(IdNameParentToJSON),
        tags: value.tags === undefined ? undefined : value.tags.map(IdNameToJSON),
        documentType: value.documentType,
        publicationDate: value.publicationDate === undefined
            ? undefined
            : value.publicationDate.toISOString(),
        publisher: IdNameToJSON(value.publisher),
        collection: IdNameToJSON(value.collection),
        match: value.match,
        matchTotal: value.matchTotal,
        authors: value.authors === undefined
            ? undefined
            : value.authors.map(IdNameToJSON),
        translations: value.translations === undefined
            ? undefined
            : value.translations.map(TranslationsToJSON)
    };
}
